import Cookies from 'js-cookie';

class AppCookies {
	UserEmailKey = '_jfue';

	saveUserEmail(email: string): void {
		Cookies.set(this.UserEmailKey, email);
	}
}

export default new AppCookies();
